export class AuthorizationError extends Error {
  name: string = "AuthorizationError";
  message: string = "Authorization token has expired. Please log in again to obtain a new token.";
}